// Define global props
var props = {};

// Convert date format to YYYY-MM-DD
function retrieveDate(ddM, mmM, yyM) {
  const today = new Date();
  let dd;
  let mm;
  let yyyy;

  if (ddM) {
    dd = today.getDate() + ddM;
  } else {
    dd = today.getDate();
  }

  if (mmM) {
    mm = today.getMonth() + (1 + mmM);
  } else {
    mm = today.getMonth() + 1;
  }

  if (yyM) {
    yyyy = today.getFullYear() + yyM;
  } else {
    yyyy = today.getFullYear();
  }

  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }

  return yyyy + "-" + mm + "-" + dd;
}

// Build String by looking and checking for values;
function buildUriString(uri, props) {
  let str = "";
  let i = 0;
  for (const key in props) {
    i++;

    if (props[key]) {
      str += i !== 1 ? "&" : "";
      str += key + "=" + props[key];
    }
  }

  return uri + str;
}

/* This script will increase the counter value, and manage the counter value if over 10 */
/* It will also avoid minus values. */

document.querySelectorAll(".counter-input").forEach((elem) => {
  let input = elem.querySelector("input");
  let plus = elem.querySelector(".plus");
  let minus = elem.querySelector(".minus");
  let max = elem.dataset.max;

  (!max) ? max = 99 : max = max;

  plus.addEventListener("click", () => {
    if(!(parseInt(input.value) == max)) {
      input.value = Number(input.value) + 1;
      updateInput();
    }
  });

  minus.addEventListener("click", () => {
    input.value = Number(input.value) - 1;
    updateInput();
  });

  function updateInput() {
    input.value = input.value ? input.value : 0;

    if (input.value < 1) {
      input.value = "1";
    }

    // if (input.value < 10) {
    //   input.value = 0 + input.value;
    // }
  }
});

bookNowPanel();
function bookNowPanel() {
  // Calculate tommorows date

  // Calculate Todays Date

  props = {
    today: retrieveDate(),
    tommorow: retrieveDate(1),
  };

  /* Fake Dropdown */
  /* Start Custom Select */
  var x, i, j, l, ll, selElmnt, a, b, c;
  /* Look for any elements with the class "custom-select": */
  x = document.getElementsByClassName("ui-dropdown");
  l = x.length;
  const innerText = [];

  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");

    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
      /* For each option in the original select element,
        create a new DIV that will act as an option item: */
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        /* When an item is clicked, update the original select box,
            and the selected item: */
        var y, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (p = 0; p < sl; p++) {
          if (s.options[p].innerHTML == this.innerHTML) {
            s.selectedIndex = p;
            h.dataset.optionSelected = this.innerHTML;
            h.innerHTML = s.dataset.name + ": " + this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
      /* When the select box is clicked, close any other select boxes,
        and open/close the current select box: */
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var x,
      y,
      i,
      xl,
      yl,
      arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }

  /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
  document.addEventListener("click", closeAllSelect);
  /* End Custom Select */

  // Array Prototype Remove Function
  Array.prototype.remove = function () {
    var what,
      a = arguments,
      L = a.length,
      ax;
    while (L && this.length) {
      what = a[--L];
      while ((ax = this.indexOf(what)) !== -1) {
        this.splice(ax, 1);
      }
    }
    return this;
  };

  /* Show / Hide options */
  //* Data Atttribute data-option-values="1,2,3,4" *//
  //* This script will seasrch for the data-option values, and once data-option is clicked it will show *//
  //* the options that are in the data-option-values attribute and hide toptions that are not active    *//
  //* according to the numbers.                                                                         *//

  let getDataOptions = document.querySelectorAll("[data-option]");
  getDataOptions.forEach((dataOption) => {
    dataOption.addEventListener("click", (e) => {
      e.preventDefault();

      getDataOptions.forEach((elem) => {
        elem.classList.remove("fill-perm");
      });

      document.querySelector(".book-now-partial").dataset.currentInterest =
        dataOption.dataset.option;

      if (dataOption.dataset.option > 2) {
        document.querySelector(
          '.book-now-date-picker[data-id="3"]'
        ).disabled = true;
        document.querySelector(
          '.book-now-date-picker[data-id="4"]'
        ).disabled = true;
      } else {
        document.querySelector(
          '.book-now-date-picker[data-id="3"]'
        ).disabled = false;
        document.querySelector(
          '.book-now-date-picker[data-id="4"]'
        ).disabled = false;
      }

      dataOption.classList.add("fill-perm");

      document.querySelectorAll("[data-option-values]").forEach((elem) => {
        document
          .querySelector("#book-now-form-cal")
          .classList.add("book-now-form-cal-disabled");

        document
          .querySelector(".book-now-partial")
          .classList.add("core-option-selected");

        document
          .querySelectorAll(".book-now-custom-date-picker")
          .forEach((bndp) => {
            bndp.classList.remove("book-now-custom-date-picker-active");
          });

        if (
          Array.from(elem.dataset.optionValues)
            .remove(",")
            .includes(dataOption.dataset.option)
        ) {
          elem.classList.add("current-option");
        } else {
          elem.classList.remove("current-option");
        }
        elem.classList.remove("disabled-option");
      });
    });
  });

  function buildOVStourURI() {
    // Define and Collect all URL values;
    let uri = "https://ovs.tour-list.com/Package/?";

    let currentTab =
      document.querySelector(".book-now-partial").dataset.currentInterest;

    //https://ovs.tour-list.com/Package/?GoDepPoint=HAN&GoArrPoint=SGN
    //&GoDepDate=2021/333333/30
    //&RtnDepDate=2021/10/31
    //&CheckInDate=2021/10/30
    //&CheckOutDate=2021/10/31
    //&CabinClass=Y&Adult=2
    //&Language=en
    //&CurrencyCode=USD
    //&HotelCode=reveriesgn

    let goDeparture = document.getElementById("book-now-airport-code").dataset
      .value;
    if (!goDeparture) {
      goDeparture = "";
    }

    let checkin = document.getElementById("book-now-checkin-value").dataset
      .value;
    if (!checkin) {
      checkin = props.today;
    }

    let checkout = document.getElementById("book-now-checkout-value").dataset
      .value;
    if (!checkout) {
      checkout = props.tommorow;
    }

    let departing = document.getElementById("book-now-departing-value").dataset
      .value;
    if (!departing) {
      departing = props.today;
    }

    let returning = document.getElementById("book-now-returning-value").dataset
      .value;
    if (!returning) {
      returning = props.tommorow;
    }

    let rooms = parseFloat(
      document.querySelector("#book-now-rooms-value .select-selected").dataset
        .optionSelected
    );
    if (!rooms) {
      rooms = 1;
    }

    let adult = parseFloat(
      document.querySelector("#book-now-adult-value .select-selected").dataset
        .optionSelected
    );
    if (!adult) {
      adult = 2;
    }

    let child = parseFloat(
      document.querySelector("#book-now-children-value .select-selected")
        .dataset.optionSelected
    );
    if (!child) {
      child = 0;
    }

    let locale = document.getElementById("book-now-locale").value;
    let language = "en";
    // Set lang accordingly to the locale variable
    if (locale == "vi_VN") {
      language = "vi";
    }
    if (locale == "zh_CN") {
      language = "zh-cn";
    }
    if (locale == "zh_TW") {
      language = "zh-tw";
    }

    // let language = document.querySelector(
    //   "#book-now-language-value .select-selected"
    // ).dataset.optionSelected;
    // if (language == "English") {
    //   language = "en";
    // }
    // if (language == "日本語") {
    //   language = "ja";
    // }
    // if (language == "简体中文") {
    //   language = "zh-cn";
    // }
    // if (language == "繁體中文") {
    //   language = "zh-tw";
    // }
    // if (!language) {
    //   language = "en";
    // } // Return to default value if undefined

    let cabinclass = document.querySelector(
      "#book-now-class-value .select-selected"
    ).dataset.optionSelected;
    if (cabinclass == "Economy") {
      cabinclass = "Y";
    }
    if (cabinclass == "Premium Economy") {
      cabinclass = "S";
    }
    if (cabinclass == "Business") {
      cabinclass = "C";
    }
    if (cabinclass == "First Class") {
      cabinclass = "F";
    }
    if (!cabinclass) {
      cabinclass = "Y";
    } // Return to default value if undefined

    let currency = document.querySelector(
      "#book-now-currency-value .select-selected"
    ).dataset.optionSelected;
    if (!currency) {
      currency = "USD";
    }

    let resRoomType = currentTab == 4 ? "reveriesgn" : "revesuite";

    // Build URI in to the props
    props.uri = {
      GoDepPoint: goDeparture,
      GoArrPoint: "SGN",

      GoDepDate: departing,
      RtnDepDate: returning,

      CheckInDate: checkin,
      CheckOutDate: checkout,

      CabinClass: cabinclass,

      Children: child,
      Adult: adult,

      Language: language,
      CurrencyCode: currency,
      HotelCode: resRoomType,
      locale: locale,
    };

    let str = "";
    let i = 0;
    for (const key in props.uri) {
      i++;

      if (props.uri[key]) {
        str += i !== 1 ? "&" : "";
        str += key + "=" + props.uri[key];
      }
    }

    return uri + str;
  }

  function buildSynxisURI() {
    // Define and Collect all URL values;
    let uri = "https://be.synxis.com/?";

    let currentTab =
      document.querySelector(".book-now-partial").dataset.currentInterest;

    let checkin = document.getElementById("book-now-checkin-value").dataset
      .value;
    if (!checkin) {
      checkin = props.today;
    }

    let checkout = document.getElementById("book-now-checkout-value").dataset
      .value;
    if (!checkout) {
      checkout = props.tommorow;
    }

    let rooms = parseFloat(
      document.querySelector("#book-now-rooms-value .select-selected").dataset
        .optionSelected
    );
    if (!rooms) {
      rooms = 1;
    }

    let adult = parseFloat(
      document.querySelector("#book-now-adult-value .select-selected").dataset
        .optionSelected
    );
    if (!adult) {
      adult = 2;
    }

    let child = parseFloat(
      document.querySelector("#book-now-children-value .select-selected")
        .dataset.optionSelected
    );
    if (!child) {
      child = 0;
    }

    let promo = document.getElementById("book-now-rates-code").value;
    //let hotel = document.getElementById('book-now-hotel-id').value;
    // let chain  = document.getElementById('book-now-chain-id').value;
    let src = document.getElementById("book-now-src-id").value;

    // let chain = currentTab == 2 ? "25113" : "24447";
    // let hotel = currentTab == 2 ? "8137" : "7060";
    // let resRoomType = currentTab == 2 ? "RELSGNRR" : "HLLW2830";


    let chain = currentTab == 2 ? "24447" : "25113";
    let hotel = currentTab == 2 ? "7060" : "8137";
    let resRoomType = currentTab == 2 ? "HLLW2830" : "RELSGNRR";

    //res-room-type=RELSGNRR
    //res-room-type=HLLW2830

    // Hotels
    // https://be.synxis.com/?res-room-type=HLLW2830&arrivalDate=23+February+2022&arrive=&departureDate=24+February+2022&depart=&rooms=1&adult=1&child=0&Promo=&Hotel=7060&Chain=24447&SRC=30

    // Apartments
    // https://be.synxis.com/?res-room-type=RELSGNRR&arrivalDate=23+February+2022&arrive=&departureDate=24+February+2022&depart=&rooms=1&adult=1&child=0&Promo=&Hotel=8137&Chain=25113&SRC=30
    // https://be.synxis.com/?res-room-type=HLLW2830&chain=7060&hotel=24447&SRC=30&arrive=2022-02-23&depart=2022-02-24&adult=2&rooms=1&locale=en_US

    let locale = document.getElementById("book-now-locale").value;

    if (locale == "vi_VN") {
      locale = "vi";
    }
    if (locale == "zh_CN") {
      locale = "zh-CN";
    }
    if (locale == "zh_TW") {
      locale = "zh-TW";
    }

    // Build URI in to the props
    props.uri = {
      "res-room-type": resRoomType,
      chain: chain,
      hotel: hotel,
      SRC: src,
      arrive: checkin,
      depart: checkout,
      child: child,
      adult: adult,
      rooms: rooms,
      Rate: promo,
      locale: locale,
    };

    // Hotel Rooms: 24447
    // Residential Suites: 25113
    // https://be.synxis.com/signIn?&chain=25113&hotel=8137&SRC=30&arrive=&Depart=&Child=&adult=&Rooms=&Rate=

    return buildUriString(uri, props.uri);
  }
  // ID 1,2
  document
    .getElementById("book-now-submit-availability")
    .addEventListener("click", (e) => {
      e.preventDefault();
      //buildSynxisURI();
      console.log(buildSynxisURI());
      window.open(buildSynxisURI(), "_blank").focus();
    });

  // ID 3,4
  document
    .getElementById("book-now-submit-submit")
    .addEventListener("click", (e) => {
      e.preventDefault();

      console.log(buildOVStourURI());

      window.open(buildOVStourURI(), "_blank").focus();

      // 25113

      // https://ovs.tour-list.com/Package/?GoDepPoint=HAN&GoArrPoint=SGN&GoDepDate=2021/10/30&RtnDepDate=2021/10/31&CheckInDate=2021/10/30&CheckOutDate=2021/10/31&CabinClass=Y&Adult=2&Language=en&CurrencyCode=USD&HotelCode=reveriesgn
    });
}

// Availability bar functionality

if (document.querySelector('.check-availability-bar input[type="submit"]')) {
  document
    .querySelector('.check-availability-bar input[type="submit"]')
    .addEventListener("click", (e) => {
      e.preventDefault();

      let submit = document.querySelector(
        '.check-availability-bar input[type="submit"]'
      );
      let uri = "https://be.synxis.com/?";

      props = {
        today: retrieveDate(),
        tommorow: retrieveDate(1),
      };

      // Reversal Date Hack
      let checkin = document.getElementById("availability-checkin-value").value;
      if (checkin) {
        checkin = checkin.replace(/\./g, "-");
        checkin = "20" + checkin.split("-").reverse().join("-");
      }

      if (!checkin) {
        checkin = props.today; // If undefined then select the prop
      }

      // Reversal Date Hack
      let checkout = document.getElementById(
        "availability-checkout-value"
      ).value;
      if (checkout) {
        checkout = checkout.replace(/\./g, "-");
        checkout = "20" + checkout.split("-").reverse().join("-");
      }

      if (!checkout) {
        checkout = props.tommorow; // If undefined then select the prop
      }

      let adult = document.getElementById("availability-adults").value;
      let children = document.getElementById("availability-children").value;
      let rooms = document.getElementById("availability-rooms").value;

      // Inherit from the book now tab values
      let hotel = document.getElementById("book-now-hotel-id").value;
      let chain = document.getElementById("book-now-chain-id").value;
      let src = document.getElementById("book-now-src-id").value;

      // let language = document.querySelector(
      //   "#book-now-language-value .select-selected"
      // ).dataset.optionSelected;
      // if (language == "English") {
      //   language = "en";
      // }
      // if (language == "日本語") {
      //   language = "ja";
      // }
      // if (language == "简体中文") {
      //   language = "zh-cn";
      // }
      // if (language == "繁體中文") {
      //   language = "zh-tw";
      // }
      // if (!language) {
      //   language = "en";
      // } // Return to default value if undefined

      let cabinclass = document.querySelector(
        "#book-now-class-value .select-selected"
      ).dataset.optionSelected;
      if (cabinclass == "Economy") {
        cabinclass = "Y";
      }
      if (cabinclass == "Premium Economy") {
        cabinclass = "S";
      }
      if (cabinclass == "Business") {
        cabinclass = "C";
      }
      if (cabinclass == "First class") {
        cabinclass = "F";
      }
      if (!cabinclass) {
        cabinclass = "Y";
      } // Return to default value if undefined

      let currency = document.querySelector(
        "#book-now-currency-value .select-selected"
      ).dataset.optionSelected;
      if (!currency) {
        currency = "USD";
      } // Return to default value if undefined

      let locale = document.getElementById("book-now-locale").value;

      if (locale == "vi_VN") {
        locale = "vi";
      }
      if (locale == "zh_CN") {
        locale = "zh-CN";
      }
      if (locale == "zh_TW") {
        locale = "zh-TW";
      }

      props.uri = {
        adult: adult,
        child : children,
        chain: chain,
        hotel: hotel,
        SRC: src,
        arrive: checkin,
        depart: checkout,
        rooms: rooms,
        locale: locale,
      };
      //console.log(buildUriString(uri, props.uri));
      window.open(buildUriString(uri, props.uri), "_blank").focus();
    });
}